/**
 * Module: web/src/main.ts
 * Author: Salvo Praxis (w/ AI pair programming partner Claude Code by Anthropic)
 * Version: 1.1.0
 * Date: 2026-07-14
 *
 * v1.1.0 (error observability, OPERATIONS-S10 -- contract
 * error-observability-api v1.0.0 SS4.2): installs the client error beacon at
 * boot -- window error/unhandledrejection capture, the localStorage staging
 * queue, and the 30 s retry delivery loop. The page provider reads the
 * router's current route so every staged error carries the SPA path the
 * user was actually on.
 *
 * SPA bootstrap -- Pinia + router + theme attribute.
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useSettingsStore } from './stores/settings';
import { installErrorBeacon } from './lib/errorBeacon';
import './assets/main.css';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

// Apply persisted theme before first paint (dark default).
useSettingsStore().applyThemeAttribute();

app.use(router);

// Error beacon (finding #2326 / durable #19): global capture + staged
// delivery. Installed after the router exists so `page` is the live route.
installErrorBeacon({ page: () => router.currentRoute.value.path });

app.mount('#app');
